import {useLanguage} from "../../../LanguageContext";
import {Box, Button, Grid, Typography} from "@mui/material";
import React, {useState} from "react";
import {gridContainer, sectionStyle} from "../../styles/TripInformationSectionStyles";
import {description, sectionTitle} from "../../styles/CommonStyles";
import ContactSection from "../../contact/ContactSection";
import {readyToTravel, readyToTravelContainer} from "../../styles/HomePageStyles";
import {ReadyToTravelComponent} from "./ReadyToTravelComponent";


const TripInformationSection = ({content}) => {
    const {t} = useLanguage();

    return (
            <Box sx={sectionStyle}>
                <Grid container
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                      alignContent="center"
                      sx={gridContainer}>

                    <Grid item
                          xs={12}
                          sm={12}
                          md={9}
                          lg={9}
                    >
                        <Box sx={{
                            color: "#FFFFFF",
                        }}>
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    pb: '24px',
                                }}
                            >
                                <Typography
                                    sx={{
                                        ...sectionTitle,
                                        ...{color: 'black'}
                                    }}>
                                    {t(content.title)}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: {
                                        xs: '100%',
                                        sm: '80%',
                                        md: '90%',
                                        lg: '60%',
                                    },
                                    ml: {
                                        xs: '0',
                                        sm: '10%',
                                        md: '5%',
                                        lg: '20%',
                                    }
                                }}
                            >
                                {t(content.descriptions).map((text, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            textAlign: 'center',
                                            pb: '12px',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...description,
                                                ...{color: 'black'}
                                            }}>
                                            {text}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{pt:'20px'}}>
                    <ReadyToTravelComponent/>
                </Box>
            </Box>
    );
}


export default TripInformationSection;
